<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary"
                style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="6">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.DateTypeFilter ||
              Filter.JobNoFilter ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.TransportTypeFilter ||
              Filter.ShipemntTypeFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.ShippingBillFilter ||
              Filter.invoiceNoFilter ||
              Filter.portNameFilter ||
              Filter.portCodeFilter ||
              Filter.fk_cu_id ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.DateTypeFilter ||
                  Filter.JobNoFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.TransportTypeFilter ||
                  Filter.ShipemntTypeFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.ShippingBillFilter ||
                  Filter.invoiceNoFilter ||
                  Filter.portNameFilter ||
                  Filter.portCodeFilter ||
                  Filter.fk_cu_id ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getPaymentList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPaymentList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
            <b-button v-if="$sessionsStorage.get('designation') == 'Admin'" class="mr-2 btn-sm" variant="primary"
              @click="clearShippingBill" :disabled="getPaymentList.length <= 0">

              <span v-if="!isClearShippingBillProcessing">Clear Shipping Bill</span>
              <span v-else>
                <b-spinner small class="mr-2"></b-spinner>
                Processing...
              </span>
            </b-button>
            <b-form-group class="pull-right ml-1 mt-1">
              <b-button variant="primary" class="d-flex align-items-center" size="sm" style="font-size: 0.675rem"
                @click="triggerFileInput">
                <md-icon class="md-size-1x nav-icon mr-2">cloud_upload</md-icon>

                <div v-if="isFileLoading" class="d-flex align-items-center">
                  <span class="mr-2">Uploading...</span>
                  <b-spinner small></b-spinner>
                </div>
                <div v-else class="d-flex align-items-center">
                  Upload File
                </div>
              </b-button>
              <input ref="fileInput" type="file" class="d-none" @change="handleFileUpload" accept=".xlsx, .xls" />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)" />
            </div>
          </b-col>
          <b-col cols="12" class="mb-2">
            <div class="p-3 text-center border rounded" :class="isDragActive ? 'border-primary bg-light' : 'border-secondary'"
              style="border-style: dashed !important; cursor: pointer;" @click="triggerFileInput" @dragover.prevent
              @dragenter.prevent="isDragActive = true" @dragleave.prevent="isDragActive = false"
              @drop.prevent="handleFileDrop">
              <strong>Drag and drop Excel file here</strong>
              <div class="text-muted">or click to browse (`.xlsx`, `.xls`)</div>
            </div>
          </b-col>

          <b-col md="3">
            <label>Date</label>
            <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
              :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
              @update="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
          </b-col>
          <b-col md="3">
            <label>Container No Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container NO Filter"
              id="ContainerNoFilter" name="ContainerNoFilter" autocomplete="off" v-model="Filter.ContainerNoFilter"
              @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
          </b-col>
          <b-col md="3">
            <label>Common Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter" id="commonFilter"
              name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
              @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
          </b-col>
          <b-col md="3">
            <label>Shipping Bill No Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Shipping Bill No"
              id="ShippingBillFilterTop" name="ShippingBillFilterTop" autocomplete="off"
              v-model="Filter.ShippingBillFilter" @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
          </b-col>
          <b-col md="3">
            <label>Invoice No Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Invoice No"
              id="invoiceNoFilterTop" name="invoiceNoFilterTop" autocomplete="off" v-model="Filter.invoiceNoFilter"
              @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
          </b-col>
          <b-col md="3">
            <label>Port Name Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Port Name" id="portNameFilterTop"
              name="portNameFilterTop" autocomplete="off" v-model="Filter.portNameFilter"
              @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
          </b-col>
          <b-col md="3">
            <label>Port Code Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Port Code" id="portCodeFilterTop"
              name="portCodeFilterTop" autocomplete="off" v-model="Filter.portCodeFilter"
              @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
          </b-col>


        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>

                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale"
                    @update="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Container No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container NO Filter"
                    id="ContainerNoFilter" name="ContainerNoFilter" autocomplete="off"
                    v-model="Filter.ContainerNoFilter" @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Shipping Bill Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Shipping Bill Filter"
                    id="ShippingBillFilter" name="ShippingBillFilter" autocomplete="off"
                    v-model="Filter.ShippingBillFilter" @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Invoice No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Invoice No"
                    id="invoiceNoFilter" name="invoiceNoFilter" autocomplete="off" v-model="Filter.invoiceNoFilter"
                    @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Port Name Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Port Name"
                    id="portNameFilter" name="portNameFilter" autocomplete="off" v-model="Filter.portNameFilter"
                    @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Port Code Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Port Code"
                    id="portCodeFilter" name="portCodeFilter" autocomplete="off" v-model="Filter.portCodeFilter"
                    @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Container Size Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container Size Filter"
                    id="ContSizeFilter" name="ContSizeFilter" autocomplete="off" v-model="Filter.ContSizeFilter"
                    @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Approved By</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Approved By Filter"
                    id="approvedBy" name="approvedBy" autocomplete="off" v-model="Filter.approvedBy"
                    @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Emp Name</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Emp Name Filter"
                    id="empNameFilter" name="empNameFilter" autocomplete="off" v-model="Filter.empNameFilter"
                    @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>


                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Created User
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="fk_cu_id"
                    @input="getBulkShippingBillList('Normal', '0', '0', '1', '1')" v-model="Filter.fk_cu_id"
                    option-value="userId" option-text="employeeName" placeholder="Select Created User" />
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">

            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="getPaymentList" :fields="PaymentFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">

                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>

              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)" />
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <b-modal id="confirm-bulk-port-expense" ref="confirm-bulk-port-expense" title="Confirm Shipping Bill" size="xl"
      no-close-on-esc no-close-on-backdrop hide-footer>

      <b-row>
        <b-col cols="12">
          <h4 class="mt-3 error" v-if="errMSG && selectedRows.length > 0">{{ errMSG }} </h4>
        </b-col>
        <b-col cols="12" v-if="isBulkShippingBillProcessing">
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <small class="text-muted">Bulk upload progress</small>
            <small class="font-weight-bold">{{ bulkProgressPercent }}%</small>
          </div>
          <b-progress :max="100" height="1.25rem" class="mb-2">
            <b-progress-bar :value="bulkProgressPercent" :label="`${bulkProgressPercent}%`"
              :variant="bulkProgressPercent >= 100 ? 'success' : 'primary'" />
          </b-progress>
        </b-col>
        <b-col md="12" class=" mt-2" v-if="selectedRows.length > 0">
          <b-button class="mr-2 btn-sm" variant="primary" @click="getSlineImportData">
           
            <span v-if="!isBulkShippingBillProcessing">Bulk Shipping Bill</span>
            <span v-else>
              <b-spinner small class="mr-2"></b-spinner>
              Processing {{ bulkProgressPercent }}%
            </span>
          </b-button>
          <b-button class="mr-2 btn-sm" variant="outline-danger" @click="resetModal">
            Cancel
          </b-button>
        </b-col>
        <b-col md="12" v-if="selectedRows.length > 0">
          <b-table :items="selectedRows" :fields="confirmFields" small responsive head-variant="light">
            <template slot="SN" slot-scope="row0"><span>{{ row0.index + 1 }}</span></template>
            <template slot="pe_container_no" slot-scope="row1">
              <span>{{ row1.item.pe_container_no }}</span><br />
              <span class="error">{{ row1.item.validationResult.MSG }}</span>
            </template>
          </b-table>
        </b-col>

        <b-col md="12" class=" mt-2" v-if="selectedRows.length > 0">
          <b-button class="mr-2 btn-sm" variant="primary" @click="getSlineImportData">
            <!-- :disabled="selectedRows.length <= 0 || invalidContainersList.length > 0" -->

            <span v-if="!isBulkShippingBillProcessing">Bulk Shipping Bill</span>
            <span v-else>
              <b-spinner small class="mr-2"></b-spinner>
              Processing {{ bulkProgressPercent }}%
            </span>
          </b-button>
          <b-button class="mr-2 btn-sm" variant="outline-danger" @click="resetModal">
            Cancel
          </b-button>
        </b-col>

      </b-row>
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-confirm :md-title="alert.title" :md-content="alert.content" :md-ok-text="alert.ok"
      @close="onConfirmClearPort" ref="confirmClearPort"></md-dialog-confirm>


  </div>
</template>

<script>
import CustomLoader from "../common/customLoader.vue";
import { excelSerialToDate } from "../../helper/filters";
import { lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import ShippingBillService from "../../services/ShippingBillService";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE } from "../../helper/constant";
import axios from "axios";
import * as XLSX from "xlsx";
import {
  debounceShippingBillFetchHelper,
  formatExcelDateHelper,
  getCurrentLastDateHelper,
  getFormatDateTimeHelper,
  parseExcelFileHelper,
} from "../../helper/shippingBillUploadHelper";


export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),

      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),

    ];
    
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    Promise.all(storePromises)
      .then(() => delay(5000)) 
      .then(() => {

      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getBulkShippingBillList("Normal", "0", "0", "1", "1");
    }
  },
  data() {
    return {
      errMSG: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getPaymentList: [],
      totalData: 0,
      confirmFields: [
        { key: 'SN', label: 'SN' },
        { key: 'msb_external_job_no', label: 'JOB NO' },
        { key: 'msb_external_job_date', label: 'JOB DATE' },
        { key: 'msb_user_job_no', label: 'USER JOB NO' },
        { key: 'msb_port_code', label: 'PORT CODE' },
        { key: 'msb_port_name', label: 'PORT NAME' },
        { key: 'msb_number', label: 'SBNUMBER' },
        { key: 'msb_date', label: 'SBDATE' },
        { key: 'msb_exporter_name', label: 'EXPORTER NAME' },
        { key: 'msb_consignee_name', label: 'CONSIGNEE NAME' },
        { key: 'msb_branch_name', label: 'BRANCH NAME' },
        { key: 'msb_tot_pkg', label: 'TOTAL PKG' },
        { key: 'msb_net_weight', label: 'NET WT.' },
        { key: 'msb_gross_weight', label: 'GROSS WT.' },
        { key: 'msb_unit_of_weight', label: 'UNIT OF WT.' },
        { key: 'msb_cha_name', label: 'CHA NAME' },
        { key: 'msb_no_of_containers', label: 'NO OF CONTAINERS' },
        { key: 'msb_invoice_no', label: 'INVOICE NO' },
        { key: 'msb_invoice_date', label: 'INVOICE DATE' },
        { key: 'msb_buyer_name', label: 'BUYER NAME' },
        { key: 'msb_port_of_desti', label: 'PORT OF DESTI.' },
        { key: 'msb_cha_code', label: 'CHA CODE' },
        { key: 'msb_external_job_created_by', label: 'JOB CREATED BY' },
      ],

      isBulkShippingBillProcessing: false,
      isClearShippingBillProcessing: false,
      isDragActive: false,
      bulkProgressPercent: 0,
      bulkTransactionNo: "",
      bulkProgressTimer: null,
      selectedRows: [],
      PaymentFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "shipping_bill",
          mainkey: "shipping_bill",
          label: "Shipping Bill",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "shipping_bill_date",
          mainkey: "shipping_bill_date",
          label: "Shipping Bill Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "external_job_no",
          mainkey: "external_job_no",
          label: "External Job No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "external_job_date",
          mainkey: "external_job_date",
          label: "External Job Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "invoice_no",
          mainkey: "invoice_no",
          label: "Invoice No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "invoice_date",
          mainkey: "invoice_date",
          label: "Invoice Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "port_name",
          mainkey: "port_name",
          label: "Port Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "port_code",
          mainkey: "port_code",
          label: "Port Code",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "cha_name",
          mainkey: "cha_name",
          label: "CHA Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "cha_code",
          mainkey: "cha_code",
          label: "CHA Code",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ContainerNo",
          mainkey: "ContainerNo",
          label: "Container NO",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Linked Job NO",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "linked_status",
          mainkey: "linked_status",
          label: "Linked",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "remarks",
          mainkey: "remarks",
          label: "Remarks",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "external_job_created_by",
          mainkey: "external_job_created_by",
          label: "Created By",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {
        ContainerNoFilter: "",
        ShippingBillFilter: "",
        invoiceNoFilter: "",
        portNameFilter: "",
        portCodeFilter: "",
        ContSizeFilter: "",
        approvedBy: "",
        empNameFilter: "",
        commonFilter: "",
        fk_cu_id: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },

      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      isLoading: false,
      generateExcel: "0",
      isFileLoading: false,

      files: [],
      fileData: null,
      presignedUrls: [],
      uploadedFiles: [],
      fileuploaded: '',
      confirm: {
        title: "Confirmation",
        content: "Are you sure you want to clear all Shipping Bills?",
        ok: "Yes",
        cancel: "No"
      },
    };
  },

  components: {
    CustomLoader,
    ModelListSelect,
    DateRangePicker,
  },
  methods: {
    getFormatDateTime() {
      return getFormatDateTimeHelper();
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async handleFileUpload(event) {
      const fileList = event && event.target ? event.target.files : null;
      if (!fileList || !fileList.length) return;
      for (let i = 0; i < fileList.length; i++) {
        this.files.push({
          name: fileList[i].name,
          progress: 0,
          file: fileList[i],
        });
      }

      const formData = new FormData();
      const userId = this.$sessionsStorage.get("loginId");

      // Append form data
      this.files.forEach((fileObj, index) => {
        formData.append("file[]", fileObj.file);
        formData.append(
          "staticFileName",
          `${fileObj.name}_FileLength_${this.files.length}_${index}_${this.getFormatDateTime()}`
        );
      });

      // Add folder and user ID to track who uploaded
      formData.append(
        "upload_dir_folderName", "Master_Port_Expense_module"
      );
      formData.append("userId", userId);

      try {
        const response = await axios.post(
          `${URL_BASE}/uploadFileCommonForAllTest31_05_2024.php`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: userId,
            },
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              this.files.forEach((fileObj) => (fileObj.progress = progress));
            },
          }
        );

        this.fileData = response.data;
        this.presignedUrls = response.data.presignedUrlArr || [];
        this.uploadedFiles = this.fileData.imgPath.split(",") || [];
        this.fileuploaded = this.fileData.imgPath;
        // Proceed with S3 upload
        await this.uploadFiles();
      } catch (error) {
        console.error("Upload error:", error);
      }

      // Excel Parsing
      const file = fileList[0];
      if (!file) return;

      this.parseExcelFile(file);
    },
    handleFileDrop(event) {
      this.isDragActive = false;
      const fileList = event && event.dataTransfer ? event.dataTransfer.files : null;
      if (!fileList || !fileList.length) return;
      this.handleFileUpload({ target: { files: fileList } });
    },


    parseExcelFile(file) {
      parseExcelFileHelper(file, {
        onStart: () => {
          this.isFileLoading = true;
        },
        onSuccess: (jsonData) => {
          const parsedData = this.parseExcelData(jsonData);
          this.selectedRows = parsedData;
          this.openConfirmModal();
          this.isFileLoading = false;
        },
        onError: (error) => {
          console.error("File reading error:", error);
          this.isFileLoading = false;
        },
      });
    },

    parseExcelData(rawData) {
      if (!Array.isArray(rawData) || rawData.length < 2) {
        return [];
      }

      const normalizeHeader = (header) => {
        return String(header || "")
          .trim()
          .toUpperCase()
          .replace(/\s+/g, " ")
          .replace(/[._-]/g, " ")
          .replace(/\s+/g, " ")
          .trim();
      };

      const aliasToKey = {
        "JOB NO": "msb_external_job_no",
        "JOB NUMBER": "msb_external_job_no",
        "EXTERNAL JOB NO": "msb_external_job_no",
        "EXTERNAL JOB NUMBER": "msb_external_job_no",

        "JOB DATE": "msb_external_job_date",
        "EXTERNAL JOB DATE": "msb_external_job_date",

        "USER JOB NO": "msb_user_job_no",
        "USER JOB NUMBER": "msb_user_job_no",

        "PORT CODE": "msb_port_code",
        "PORTCODE": "msb_port_code",

        "PORT NAME": "msb_port_name",
        "PORTNAME": "msb_port_name",

        "SBNUMBER": "msb_number",
        "SB NUMBER": "msb_number",
        "SHIPPING BILL NO": "msb_number",
        "SHIPPING BILL NUMBER": "msb_number",

        "SBDATE": "msb_date",
        "SB DATE": "msb_date",
        "SHIPPING BILL DATE": "msb_date",

        "EXPORTER NAME": "msb_exporter_name",
        "EXPORTER": "msb_exporter_name",

        "CONSIGNEE NAME": "msb_consignee_name",
        "CONSIGNEE": "msb_consignee_name",

        "CHA NAME": "msb_cha_name",
        "CHA": "msb_cha_name",

        "NO OF CONTAINERS": "msb_no_of_containers",
        "NO OF CONTAINER": "msb_no_of_containers",
        "NO OF CNTRS": "msb_no_of_containers",
        "NO OF CNTR": "msb_no_of_containers",
        "CONTAINER COUNT": "msb_no_of_containers",

        "INVOICE NO": "msb_invoice_no",
        "INVOICE NUMBER": "msb_invoice_no",

        "INVOICE DATE": "msb_invoice_date",
        "INV DATE": "msb_invoice_date",

        "BUYER NAME": "msb_buyer_name",
        "BUYER": "msb_buyer_name",

        "PORT OF DESTI": "msb_port_of_desti",
        "PORT OF DESTI.": "msb_port_of_desti",
        "PORT OF DESTINATION": "msb_port_of_desti",
        "DESTINATION PORT": "msb_port_of_desti",

        "CHA CODE": "msb_cha_code",

        "JOB CREATED BY": "msb_external_job_created_by",
        "CREATED BY": "msb_external_job_created_by",

        "BRANCH NAME": "msb_branch_name",
        "BRANCH": "msb_branch_name",

        "TOT PKG": "msb_tot_pkg",
        "TOTAL PKG": "msb_tot_pkg",
        "TOTAL PKGS": "msb_tot_pkg",
        "TOTAL PACKAGE": "msb_tot_pkg",
        "TOTAL PACKAGES": "msb_tot_pkg",

        "NET WEIGHT": "msb_net_weight",
        "NET WT": "msb_net_weight",
        "NET WT.": "msb_net_weight",

        "GROSS WEIGHT": "msb_gross_weight",
        "GROSS WT": "msb_gross_weight",
        "GROSS WT.": "msb_gross_weight",
        "UNIT OF WT.": "msb_unit_of_weight",
        "UNIT OF WT": "msb_unit_of_weight",
        "UNIT OF WEIGHT": "msb_unit_of_weight",
        "WEIGHT UNIT": "msb_unit_of_weight",
      };

      const dateKeys = new Set([
        "msb_external_job_date",
        "msb_date",
        "msb_invoice_date",
      ]);

      const headers = rawData[0].map((header) => normalizeHeader(header));
      const rows = rawData.slice(1);

      const result = rows
        .filter(row => row && row.length > 0 && row.some(cell => cell !== undefined && cell !== null && cell !== ''))
        .map(row => {
          const obj = {};

          headers.forEach((header, index) => {
            const value = row[index];
            const targetKey = aliasToKey[header];
            if (!targetKey) return;

            if (dateKeys.has(targetKey)) {
              obj[targetKey] = this.formatExcelDate(value) || null;
            } else {
              obj[targetKey] = value ? value.toString() : '' || null;
            }
          });
          return obj;
        });

      return result;
    },
    formatExcelDate(value) {
      return formatExcelDateHelper(value, excelSerialToDate);
    },

    async uploadFiles() {
      try {
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i].file;
          const presignedUrl = this.presignedUrls[i];
          if (presignedUrl) {
            await this.uploadFileToS3(file, presignedUrl, i);
          }
        }
      } catch (error) {
        console.error("Error uploading files to S3:", error);
      }
    },

    uploadFileToS3(file, presignedUrl, index) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", presignedUrl, true);
        xhr.setRequestHeader("Content-Type", file.type);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const progress = (event.loaded / event.total) * 100;
            this.files[index].progress = Math.round(progress);
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve();
          } else {
            reject(`Upload failed with status ${xhr.status}`);
          }
        };

        xhr.onerror = () => reject("Upload failed due to network error.");

        xhr.send(file);
      });
    },
    clearShippingBill() {
      if (this.getPaymentList.length > 0) {
        this.$refs.confirmClearPort.open(); // just open — no `.then()`
      } else {
        console.log("Please choose at least one valid Shipping Bill.");
      }
    },

    onConfirmClearPort(type) {

      if (this.getPaymentList.length > 0) {
        if (type == "ok") {
          this.isClearShippingBillProcessing = true;
          ShippingBillService.clearShippingBill({})
            .then((response) => {
              const { data, status, statusText } = response;
              if (status == 200 && data) {
                this.isClearShippingBillProcessing = false;
                this.getBulkShippingBillList("Normal", "0", "0", "1", "1");
              }
              this.isLoading = false;
            })
            .catch((error) => {
              console.log("Catch on clearShippingBill Error: ", error);
            });
        } else {
          console.log("Clear Shipping Bill cancelled by user.");
        }
      } else {
        console.log("Please Choose Atleast One Correct Shipping Bill List ");
      }
    },

    getSlineImportData() {
      this.errMSG = "";
      let payload = { excel_data: this.selectedRows, pel_doc_url: this.fileuploaded, pel_doc_name: this.fileuploaded, chunk_size: 500 };
      if (this.selectedRows.length > 0) {
        this.isBulkShippingBillProcessing = true;
        this.bulkProgressPercent = 0;
        ShippingBillService.upsertExcelBulkShippingBill(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            const txNo = response.data.transaction_no;
            if (txNo) {
              this.bulkTransactionNo = txNo;
              this.startBulkProgressPolling(txNo);
            }
            if (response.data && response.data.error) {
              this.alert.content = response.data.error;
              this.$refs["addPop"].open();
            }

            if (status == 200 && data) {
              // Wait for progress endpoint to mark completion.
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on getSlineImportData Error: ", error);
            this.stopBulkProgressPolling();
            this.isBulkShippingBillProcessing = false;
          });
      } else {
        console.log("PLease Choose Atleast One Correct Ledger List ");
      }
    },
    startBulkProgressPolling(transactionNo) {
      this.stopBulkProgressPolling();
      this.bulkProgressTimer = setInterval(() => {
        ShippingBillService.getBulkShippingBillProgress({ transaction_no: transactionNo })
          .then((response) => {
            const progress = response.data.data;
            if (!progress) return;

            this.bulkProgressPercent = progress.percent || 0;
            if (progress.status === "completed") {
              this.bulkProgressPercent = 100;
              this.isBulkShippingBillProcessing = false;
              this.selectedRows = [];
              this.resetModal();
              this.getBulkShippingBillList("Normal", "0", "0", "1", "1");
              this.stopBulkProgressPolling();
            } else if (progress.status === "failed") {
              this.isBulkShippingBillProcessing = false;
              this.alert.content = progress.error || "Bulk processing failed";
              this.$refs["addPop"].open();
              this.stopBulkProgressPolling();
            }
          })
          .catch((error) => {
            console.log("Catch on bulk progress poll Error: ", error);
          });
      }, 1200);
    },
    stopBulkProgressPolling() {
      if (this.bulkProgressTimer) {
        clearInterval(this.bulkProgressTimer);
        this.bulkProgressTimer = null;
      }
    },

    openConfirmModal() {
      this.$refs["confirm-bulk-port-expense"].show();
    },
    resetModal() {
      // Reset state each time modal is closed
      this.stopBulkProgressPolling();
      this.selectedRows = [];
      this.errMSG = "";
      this.$refs["confirm-bulk-port-expense"].hide();
    },

    clearFilter() {
      this.Filter = {
        ContainerNoFilter: "",
        ShippingBillFilter: "",
        invoiceNoFilter: "",
        portNameFilter: "",
        portCodeFilter: "",
        ContSizeFilter: "",
        approvedBy: "",
        empNameFilter: "",
        commonFilter: "",
        fk_cu_id: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getBulkShippingBillList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      const { startDate, endDate } = getCurrentLastDateHelper();
      this.startDate = startDate;
      this.Filter.dateRange = {
        startDate,
        endDate,
      };
    },

    getBulkShippingBillList(type, filterIdD, CURRENT, SEARCH, pageNumber) {

      this.totalData = 0;
      this.getPaymentList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = false;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        linkedSB: localStorage.getItem("linkedSB")
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      ShippingBillService.getAllShippingBillList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              this.downloadShippingBillExcelWithDateCells(data);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getBulkShippingBillList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.total;
                this.getPaymentList = data.data;
                this.pagination.totalRows = data.meta.total;
                this.pagination.currentPage = data.meta.currentPage;
                this.pagination.perPage = data.meta.pageSize;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      debounceShippingBillFetchHelper(this);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getBulkShippingBillList("Excell", "0", "0", "1", "1");
    },
    downloadShippingBillExcelWithDateCells(blobData) {
      try {
        const reader = new FileReader();
        reader.onload = (evt) => {
          try {
            const workbook = XLSX.read(evt.target.result, { type: "array", cellDates: true });
            const sheetName = workbook.SheetNames && workbook.SheetNames.length ? workbook.SheetNames[0] : null;
            if (!sheetName) {
              this.downloadRawShippingBillExcel(blobData);
              return;
            }

            const ws = workbook.Sheets[sheetName];
            const ref = ws["!ref"];
            if (!ref) {
              this.downloadRawShippingBillExcel(blobData);
              return;
            }

            const targetHeaders = new Set([
              "shipping_bill_date",
              "external_job_date",
              "invoice_date",
              "created_at",
              "updated_at",
              "GrnDate",
              "SBillDate",
              "SinvDate",
              "JobDate",
              "EnqDate",
              "MBLDate",
              "SOBDate",
              "MBLReleaseDate",
            ]);

            const range = XLSX.utils.decode_range(ref);
            const headerRow = range.s.r;
            const dateCols = [];

            for (let c = range.s.c; c <= range.e.c; c++) {
              const headerCellRef = XLSX.utils.encode_cell({ r: headerRow, c });
              const headerCell = ws[headerCellRef];
              if (!headerCell || headerCell.v == null) continue;
              const header = String(headerCell.v).trim();
              if (targetHeaders.has(header)) {
                dateCols.push(c);
              }
            }

            if (dateCols.length) {
              for (let r = headerRow + 1; r <= range.e.r; r++) {
                for (let i = 0; i < dateCols.length; i++) {
                  const c = dateCols[i];
                  const cellRef = XLSX.utils.encode_cell({ r, c });
                  const cell = ws[cellRef];
                  if (!cell || cell.v == null || cell.v === "") continue;
                  const parsedDate = this.parseExcelDateValue(cell.v);
                  if (!parsedDate) continue;
                  ws[cellRef] = { t: "d", v: parsedDate, z: "dd mmm yyyy" };
                }
              }
            }

            const out = XLSX.write(workbook, { bookType: "xlsx", type: "array", cellDates: true });
            const blob = new Blob([out], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "get-Port-Expense-report.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (e) {
            console.error("Failed to rewrite Excel date columns:", e);
            this.downloadRawShippingBillExcel(blobData);
          }
        };
        reader.onerror = () => this.downloadRawShippingBillExcel(blobData);
        reader.readAsArrayBuffer(blobData);
      } catch (e) {
        console.error("Failed to process export file:", e);
        this.downloadRawShippingBillExcel(blobData);
      }
    },
    parseExcelDateValue(value) {
      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return new Date(value.getFullYear(), value.getMonth(), value.getDate());
      }
      if (typeof value === "number" && Number.isFinite(value)) {
        const parsed = XLSX.SSF.parse_date_code(value);
        if (parsed && parsed.y && parsed.m && parsed.d) {
          return new Date(parsed.y, parsed.m - 1, parsed.d);
        }
      }
      const raw = String(value || "").trim();
      if (!raw) return null;

      // Normalize ISO-like values to date-only and avoid timezone shifts.
      const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        const y = Number(isoMatch[1]);
        const m = Number(isoMatch[2]) - 1;
        const d = Number(isoMatch[3]);
        if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(d)) {
          return new Date(y, m, d);
        }
      }

      const parsed = new Date(raw);
      if (!Number.isNaN(parsed.getTime())) {
        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
      }
      return null;
    },
    downloadRawShippingBillExcel(blobData) {
      const blob = new Blob([blobData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "get-Port-Expense-report.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBulkShippingBillList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBulkShippingBillList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>


// WEBPACK FOOTER //
// shippingBillUpload.vue?a0367b0a